module.exports = __webpack_public_path__ + "img/background-undefined@2x.747c92b4.jpg";